import { css } from 'styled-components';
import { rootStore } from '../mobx/rootStore';

const { appStore } = rootStore;
const { themeMode } = appStore || {};

export const LineClamp = (lines: number = 1) => css`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
`;

export const HideScrollbar = css`
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ShowVerticalScrollbar = css`
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: ${({ theme }) => (themeMode?.theme === 'dark' ? '#797979' : '#9b9fa3')};
  }
`;

export const ShowHorizontalScrollbar = css`
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: ${({ theme }) => (themeMode?.theme === 'dark' ? '#797979' : '#9b9fa3')};
  }
`;

export const ShowTransparentVerticalScrollbar = css`
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: transparent;
  }
`;

export const FlexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlexBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AlignCenter = css`
  display: flex;
  align-items: center;
`;
